import React from 'react'
import SearchContext from './SearchContext'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Popover from '@material-ui/core/Popover'
import PopupState from 'material-ui-popup-state'
import {
  usePopupState,
  bindTrigger,
  bindPopover,
  bindToggle
} from 'material-ui-popup-state/hooks'
import Grid from '@material-ui/core/Grid'
import NotificationsIcon from '@material-ui/icons/Notifications'
import { mongodb, useAuth } from './Auth//use-auth'
//import RecocnizeSystem from './components/RecocnizeSystem'
import { Link } from 'react-router-dom'
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider
} from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import moment from 'moment'
import 'moment/locale/et'
const useStyles = makeStyles(theme => ({
  root1: {
    margin: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1)
    }
  }
}))
//const theme = createMuiTheme({})
export default function PopoverPopupState () {
  const classes = useStyles()
  //const classes = theme()
  const { selectedDate, setSelectedDate } = React.useContext(SearchContext)
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'popup1'
  })
  const { auth, user } = useAuth()
  const db = mongodb.db('silmandDB')
  const [activeJobs, setActiveJobs] = React.useState([{}])
  console.log('loetud read3', activeJobs)
  React.useEffect(() => {
    if ('user') {
      findActive()
      console.log('loetud read2', activeJobs)
    } else {
      console.log('ei toimi', auth)
      window.alert('Vaja sisse logida')
    }
  }, [])

  const findActive = async () => {
    try {
      await db
        .collection('items')
        .find({ status: 0 })
        .asArray()
        .then(aj => {
          setActiveJobs(aj)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      console.log('loetud read1', activeJobs)
    }
  }
  const ListActiveJob = aj => {
    console.log('listactiveJob', aj)

    // <h4>
    //   tood{' '}
    //   {gr.map(job => {
    //     JSON.stringify(job)
    //   })}
    // </h4>
    return 'true'
  }
  const handleClick = starttime => {
    console.log('params', starttime)
    setSelectedDate(starttime)
    return popupState.close()
  }
  return (
    <PopupState key={1111} variant='popover' popupId='popup1'>
      {popupState => (
        <div>
          <Button
            variant='contained'
            color='primary'
            {...bindTrigger(popupState)}
          >
            <NotificationsIcon />
          </Button>

          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <Grid container spacing={2} alignItems='stretch'>
              <Box p={2} className={classes.root1}>
                <button onClick={() => popupState.close()}>vajuta kinni</button>

                {activeJobs.map((activeJob, index) => (
                  <Paper
                    key={index}
                    elevation={3}
                    square
                    className={classes.root1}
                    style={{ background: activeJob.bgColor }}
                  >
                    <button
                      className={classes.root1}
                      {...bindTrigger(popupState)}
                      key={index}
                      onClick={() => {
                        handleClick(activeJob.start_time)
                      }}
                    >
                      {`${activeJob.title} ${moment(
                        activeJob.start_time
                      ).format('MM/DD/YY')}`}
                    </button>
                  </Paper>
                ))}
              </Box>
            </Grid>
          </Popover>
        </div>
      )}
    </PopupState>
  )
}
// <Link key={index} to={'/update/' + activeJob._id}>  </Link>
// bgColor: "#80cbc4"
// carId: 24
// carNumber: "123MAK"
// clientId: 78
// clientShortName: "Silmand Car Service"
// end_time: 1595493900000
// group: 23
// odo: "5005"
// owner_id: "5e5f9ddd10a95d2572aa83b0"
// solved: null
// start_time: 1595482200000
// status: 0
// symptoms: null
// title: "scs 123MAK"
// _id: 738816
